import script from "./MsgSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./MsgSidebar.vue?vue&type=script&setup=true&lang=js"

import "./MsgSidebar.vue?vue&type=style&index=0&id=b513385c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b513385c"]])

export default __exports__